module.exports = __webpack_public_path__ + "img/download-3-panel-3-INT.978be579.png";